export const DECIMAL_PRECISION = 3;
const DECIMAL_FACTOR = 10 ** DECIMAL_PRECISION;

export function normalizeDecimalInput(value: string): string {
  if (typeof value !== "string") return String(value);
  return value.replaceAll(",", ".").replaceAll(/[^0-9.+]/g, "");
}

/** Round a number to DECIMAL_PRECISION decimals (for computed values, not display). */
export function roundDecimal(v: number): number {
  return Math.round(v * DECIMAL_FACTOR) / DECIMAL_FACTOR;
}

export function formatDecimal(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "";
  return String(roundDecimal(v));
}
